import {TO_CHECK_REASON_LABELS} from '../../../../../types/enums.ts';
import {cn} from '../../../../../lib/utils.ts';
import type {ToCheckReason} from '../../../../../generated/enums.ts';

const REASON_STYLES: Record<ToCheckReason, string> = {
    needs_review: 'bg-orange-300 ring-orange-200',
    needs_category: 'bg-violet-200 ring-violet-100',
    awaiting_scan: 'bg-gray-200 ring-gray-100',
};

export function ToCheckReasonTag({reason}: { reason: ToCheckReason }) {
    return (
        <span
            className={cn(
                'inline-flex items-center gap-1.5 rounded-full px-3 py-0.5 text-[10px] font-bold text-gray-900 ring-1 ring-inset whitespace-nowrap',
                REASON_STYLES[reason],
            )}
        >
            {reason === 'awaiting_scan' && (
                <span className="h-1.5 w-1.5 rounded-full bg-gray-500 animate-pulse" />
            )}
            {TO_CHECK_REASON_LABELS[reason]}
        </span>
    );
}
